import classnames from 'classnames';
import { useTranslation } from 'react-i18next';
import IconInfo from './icon_info.svg';
import s from './index.module.scss';

export const VatWarning = ({ className }) => {
  const { t } = useTranslation('fundraising');
  return (
    <div className={classnames(s.wrapper, className)}>
      <img src={IconInfo} alt="info" width={24} height={24} />
      <span>{t('vat_warning.text')}</span>
    </div>
  );
};
